import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Message } from 'element-ui';
import * as api from '@/api';

// 导入全局样式
import './styles/index.scss';

Vue.config.productionTip = false;

// 初始化主题
const savedTheme = localStorage.getItem('theme');
if (savedTheme === 'dark') {
  document.documentElement.classList.add('dark-theme');
}

// 使用插件
Vue.use(ElementUI);

// 配置 Message 全局默认参数
// offset: 160px 表示距离顶部 160px，避免遮挡工具栏和页面元素
// duration: 3000ms 表示 3 秒后自动消失
const MESSAGE_DEFAULT_CONFIG = {
  offset: 160,
  duration: 3000
};

// 包装 Message 函数，添加点击关闭功能
const originalMessage = Message;

// 创建增强的 message 函数
const enhancedMessage = function(options) {
  // 合并默认配置
  const config = typeof options === 'string' 
    ? { ...MESSAGE_DEFAULT_CONFIG, message: options }
    : { ...MESSAGE_DEFAULT_CONFIG, ...options };
    
  const instance = originalMessage(config);
  // 为 Message 元素添加点击关闭功能
  if (instance && instance.$el) {
    instance.$el.addEventListener('click', () => {
      instance.close();
    });
  }
  return instance;
};

// 保留原始的快捷方法
enhancedMessage.success = function(options) {
  const config = typeof options === 'string' 
    ? { ...MESSAGE_DEFAULT_CONFIG, message: options, type: 'success' }
    : { ...MESSAGE_DEFAULT_CONFIG, ...options, type: 'success' };
  return enhancedMessage(config);
};

enhancedMessage.error = function(options) {
  const config = typeof options === 'string' 
    ? { ...MESSAGE_DEFAULT_CONFIG, message: options, type: 'error' }
    : { ...MESSAGE_DEFAULT_CONFIG, ...options, type: 'error' };
  return enhancedMessage(config);
};

enhancedMessage.warning = function(options) {
  const config = typeof options === 'string' 
    ? { ...MESSAGE_DEFAULT_CONFIG, message: options, type: 'warning' }
    : { ...MESSAGE_DEFAULT_CONFIG, ...options, type: 'warning' };
  return enhancedMessage(config);
};

enhancedMessage.info = function(options) {
  const config = typeof options === 'string' 
    ? { ...MESSAGE_DEFAULT_CONFIG, message: options, type: 'info' }
    : { ...MESSAGE_DEFAULT_CONFIG, ...options, type: 'info' };
  return enhancedMessage(config);
};

// 挂载到 Vue 原型
Vue.prototype.$message = enhancedMessage;

// 挂载 API 到 Vue 原型
Vue.prototype.$api = api;

// 创建 Vue 实例
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
